import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/esnext.json.parse.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4"
};
const _hoisted_2 = {
  class: "text-xs text-slate-500"
};
const _hoisted_3 = {
  class: "text-primary-600"
};
const _hoisted_4 = {
  class: "overflow-y-auto max-h-[calc(90vh-140px)] px-6 pb-6"
};
const _hoisted_5 = {
  key: 0,
  class: "py-12 text-center text-sm text-slate-500"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "pt-6 grid grid-cols-1 gap-4 lg:grid-cols-3"
};
const _hoisted_8 = {
  class: "rounded-xl border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_9 = {
  class: "mt-1 text-base font-semibold text-slate-900"
};
const _hoisted_10 = {
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_11 = {
  class: "rounded-xl border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_12 = {
  class: "mt-1 text-base font-semibold text-slate-900"
};
const _hoisted_13 = {
  key: 0,
  class: "text-xs font-normal text-amber-600"
};
const _hoisted_14 = {
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_15 = {
  key: 0,
  class: "text-amber-600"
};
const _hoisted_16 = {
  class: "rounded-xl border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_17 = {
  class: "mt-1 text-base font-semibold text-slate-900"
};
const _hoisted_18 = {
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_19 = {
  class: "mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2"
};
const _hoisted_20 = {
  class: "rounded-xl border border-slate-200 p-4"
};
const _hoisted_21 = {
  class: "mt-3 space-y-2 text-sm text-slate-600"
};
const _hoisted_22 = {
  class: "flex justify-between"
};
const _hoisted_23 = {
  class: "text-slate-900"
};
const _hoisted_24 = {
  class: "flex justify-between"
};
const _hoisted_25 = {
  class: "text-slate-900"
};
const _hoisted_26 = {
  class: "flex justify-between"
};
const _hoisted_27 = {
  class: "text-slate-900"
};
const _hoisted_28 = {
  class: "flex justify-between"
};
const _hoisted_29 = {
  class: "text-slate-900"
};
const _hoisted_30 = {
  class: "flex justify-between"
};
const _hoisted_31 = {
  class: "text-slate-900"
};
const _hoisted_32 = {
  class: "rounded-xl border border-slate-200 p-4"
};
const _hoisted_33 = {
  class: "mt-4 space-y-3"
};
const _hoisted_34 = {
  class: "relative"
};
const _hoisted_35 = {
  class: "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-600 text-sm font-semibold text-white shadow-sm"
};
const _hoisted_36 = {
  key: 0,
  class: "absolute left-1/2 top-10 h-3 w-px -translate-x-1/2 bg-slate-200"
};
const _hoisted_37 = {
  class: "flex-1 pt-0.5"
};
const _hoisted_38 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_39 = {
  key: 0,
  class: "mt-2 rounded-md bg-amber-50 px-3 py-2 text-xs text-slate-700"
};
const _hoisted_40 = {
  class: "flex items-start gap-2"
};
const _hoisted_41 = {
  key: 1,
  class: "flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-slate-200 bg-slate-50/50 p-8"
};
const _hoisted_42 = {
  class: "mt-6 rounded-xl border border-slate-200 p-4"
};
const _hoisted_43 = {
  class: "mt-3 text-sm text-slate-600 leading-relaxed"
};
const _hoisted_44 = {
  class: "mt-6 rounded-xl border border-slate-200 p-4"
};
const _hoisted_45 = {
  class: "mt-3 space-y-2"
};
const _hoisted_46 = {
  class: "font-medium text-slate-900"
};
const _hoisted_47 = {
  class: "ml-2 text-xs text-slate-500"
};
const _hoisted_48 = {
  class: "flex items-center gap-3 text-xs"
};
const _hoisted_49 = {
  class: "text-slate-500"
};
const _hoisted_50 = {
  key: 0,
  class: "rounded-lg border border-dashed border-slate-200 p-3 text-center text-xs text-slate-500"
};
const _hoisted_51 = {
  class: "mt-6 rounded-xl border border-slate-200 p-4"
};
const _hoisted_52 = {
  class: "mt-4 space-y-4"
};
const _hoisted_53 = {
  class: "flex flex-wrap items-center justify-between gap-2"
};
const _hoisted_54 = {
  class: "text-sm font-semibold text-slate-900"
};
const _hoisted_55 = {
  class: "text-sm text-primary-600"
};
const _hoisted_56 = {
  key: 0,
  class: "mt-3 text-sm text-slate-600"
};
const _hoisted_57 = {
  key: 1,
  class: "mt-3 text-sm text-slate-600"
};
const _hoisted_58 = {
  key: 2,
  class: "mt-3 space-y-2 text-sm text-slate-600"
};
const _hoisted_59 = {
  class: "text-slate-900"
};
const _hoisted_60 = {
  key: 0,
  class: "rounded-lg bg-slate-50 px-3 py-2"
};
import { computed, ref, watch } from 'vue';
import { getProductDetail } from '@/api';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'ProductDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    productId: {
      type: [Number, String],
      default: null
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const visible = ref(false);
    const loading = ref(false);
    const detail = ref(null);
    watch(() => props.modelValue, val => {
      visible.value = val;
      if (val && props.productId) {
        loadDetail();
      }
    }, {
      immediate: true
    });
    watch(visible, val => {
      if (!val) {
        emit('update:modelValue', false);
      }
    });
    const categoryName = computed(() => {
      if (!detail.value?.categoryId) return '-';
      const category = props.categories.find(item => item.id === detail.value.categoryId);
      return category ? category.name : '-';
    });
    const priceDisplay = computed(() => {
      return detail.value?.priceModels?.[0]?.priceDisplay || detail.value?.summary || '-';
    });
    const processStepsList = computed(() => {
      const steps = detail.value?.processSteps;

      // 如果是数组，直接排序返回
      if (Array.isArray(steps)) {
        return steps.sort((a, b) => (a.sort || 0) - (b.sort || 0));
      }

      // 如果是 JSON 字符串，解析后返回
      if (typeof steps === 'string' && steps.trim()) {
        try {
          const parsed = JSON.parse(steps);
          if (Array.isArray(parsed)) {
            return parsed.sort((a, b) => (a.sort || 0) - (b.sort || 0));
          }
        } catch (error) {
          console.error('解析流程步骤 JSON 失败:', error);
        }
      }
      return [];
    });
    const pricingTypeLabel = type => {
      const map = {
        FIXED: '固定价',
        RANGE: '区间价',
        TIER: '阶梯价',
        ITEMIZED: '计项价',
        QUOTE: '面议',
        SUBSCRIPTION: '订阅价'
      };
      return map[type] || type;
    };
    const loadDetail = async () => {
      if (!props.productId) return;
      loading.value = true;
      try {
        detail.value = await getProductDetail(props.productId);
      } catch (error) {
        console.error('加载产品详情失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const close = () => {
      visible.value = false;
      emit('update:modelValue', false);
      emit('close');
    };
    return (_ctx, _cache) => {
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createBlock(AppModal, {
        visible: visible.value,
        size: "5xl",
        scrollable: false,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_cache[1] || (_cache[1] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "产品详情", -1)), _createElementVNode("p", _hoisted_2, [_cache[0] || (_cache[0] = _createTextVNode("展示价：", -1)), _createElementVNode("span", _hoisted_3, _toDisplayString(priceDisplay.value), 1)])]), _createElementVNode("button", {
          onClick: close,
          class: "rounded-full p-1 text-slate-400 hover:text-slate-600"
        }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_4, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, "加载详情中...")) : detail.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "产品名称", -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(detail.value.name), 1), _createElementVNode("div", _hoisted_10, "产品编码：" + _toDisplayString(detail.value.code), 1)]), _createElementVNode("div", _hoisted_11, [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "当前版本", -1)), _createElementVNode("div", _hoisted_12, [_createTextVNode(" v" + _toDisplayString(detail.value.versionNo) + " ", 1), detail.value.onlineVersionNo ? (_openBlock(), _createElementBlock("span", _hoisted_13, "（待审草稿，线上 v" + _toDisplayString(detail.value.onlineVersionNo) + "）", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_createTextVNode(" 状态：" + _toDisplayString(detail.value.status === 1 ? '上架' : '下架') + " ", 1), detail.value.approvalInstanceId ? (_openBlock(), _createElementBlock("span", _hoisted_15, " ，" + _toDisplayString(detail.value.approvalAction === 'UNPUBLISH' ? '下架审批中' : '上架审批中'), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_16, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "text-xs text-slate-500"
        }, "类型", -1)), _createElementVNode("div", _hoisted_17, _toDisplayString(categoryName.value), 1), _createElementVNode("div", _hoisted_18, "周期：" + _toDisplayString(detail.value.durationDays) + " 天", 1)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[11] || (_cache[11] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "基础信息", -1)), _createElementVNode("dl", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "摘要", -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(detail.value.summary || '-'), 1)]), _createElementVNode("div", _hoisted_24, [_cache[7] || (_cache[7] = _createElementVNode("span", null, "服务范围", -1)), _createElementVNode("span", _hoisted_25, _toDisplayString(detail.value.serviceScope || '-'), 1)]), _createElementVNode("div", _hoisted_26, [_cache[8] || (_cache[8] = _createElementVNode("span", null, "交付物", -1)), _createElementVNode("span", _hoisted_27, _toDisplayString(detail.value.deliverables || '-'), 1)]), _createElementVNode("div", _hoisted_28, [_cache[9] || (_cache[9] = _createElementVNode("span", null, "注意事项", -1)), _createElementVNode("span", _hoisted_29, _toDisplayString(detail.value.notices || '-'), 1)]), _createElementVNode("div", _hoisted_30, [_cache[10] || (_cache[10] = _createElementVNode("span", null, "关联方案审批", -1)), _createElementVNode("span", _hoisted_31, _toDisplayString(detail.value.needApproval === 1 ? '需要审批' : '无需审批'), 1)])])]), _createElementVNode("div", _hoisted_32, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "flex items-center gap-2"
        }, [_createElementVNode("svg", {
          class: "h-5 w-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        })]), _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "流程步骤")], -1)), _createElementVNode("div", _hoisted_33, [processStepsList.value && processStepsList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(processStepsList.value, (step, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "relative flex items-start gap-4 rounded-lg bg-gradient-to-br from-slate-50 to-white p-4 shadow-sm transition-all hover:shadow-md"
          }, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(step.sort || index + 1), 1), index < processStepsList.value.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_36)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(step.name), 1), step.notes ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_cache[12] || (_cache[12] = _createElementVNode("svg", {
            class: "mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-500",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createElementVNode("span", null, _toDisplayString(step.notes), 1)])])) : _createCommentVNode("", true)])]);
        }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[13] || (_cache[13] = [_createElementVNode("div", {
          class: "flex h-12 w-12 items-center justify-center rounded-full bg-slate-100"
        }, [_createElementVNode("svg", {
          class: "h-6 w-6 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        })])], -1), _createElementVNode("p", {
          class: "mt-3 text-sm font-medium text-slate-600"
        }, "暂无流程步骤", -1)]))]))])])]), _createElementVNode("div", _hoisted_42, [_cache[15] || (_cache[15] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "详情介绍", -1)), _withDirectives(_createElementVNode("div", _hoisted_43, null, 512), [[_directive_safe_html, detail.value.detailContent || '暂无内容']])]), _createElementVNode("div", _hoisted_44, [_cache[16] || (_cache[16] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "所需资料", -1)), _createElementVNode("div", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.materials, material => {
          return _openBlock(), _createElementBlock("div", {
            key: material.materialDefinitionId,
            class: "flex items-center justify-between rounded-lg bg-slate-50 px-3 py-2 text-sm"
          }, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_46, _toDisplayString(material.name), 1), _createElementVNode("span", _hoisted_47, _toDisplayString(material.code), 1)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("span", {
            class: _normalizeClass(material.isRequired ? 'text-red-500' : 'text-slate-500')
          }, _toDisplayString(material.isRequired ? '必填' : '选填'), 3), _createElementVNode("span", _hoisted_49, _toDisplayString(material.allowMultiple ? '可多份' : '单份'), 1)])]);
        }), 128)), !detail.value.materials?.length ? (_openBlock(), _createElementBlock("div", _hoisted_50, " 暂无资料要求 ")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_51, [_cache[18] || (_cache[18] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-900"
        }, "价格模型", -1)), _createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.priceModels, model => {
          return _openBlock(), _createElementBlock("div", {
            key: model.id,
            class: "rounded-xl border border-slate-200 p-4"
          }, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(pricingTypeLabel(model.pricingType)), 1), _createElementVNode("div", _hoisted_55, _toDisplayString(model.priceDisplay || '-'), 1)]), model.pricingType === 'RANGE' ? (_openBlock(), _createElementBlock("div", _hoisted_56, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.items, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "rounded-lg bg-slate-50 px-3 py-2"
            }, " 区间价：" + _toDisplayString(item.priceMin) + " - " + _toDisplayString(item.priceMax) + " " + _toDisplayString(model.currency), 1);
          }), 128))])) : model.pricingType === 'QUOTE' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [...(_cache[17] || (_cache[17] = [_createElementVNode("div", {
            class: "rounded-lg bg-slate-50 px-3 py-2"
          }, "价格面议", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.items, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "flex items-center justify-between rounded-lg bg-slate-50 px-3 py-2"
            }, [_createElementVNode("span", null, _toDisplayString(item.name || '价格项'), 1), _createElementVNode("span", _hoisted_59, _toDisplayString(item.price) + " " + _toDisplayString(model.currency), 1)]);
          }), 128)), !model.items?.length ? (_openBlock(), _createElementBlock("div", _hoisted_60, "暂无价格项")) : _createCommentVNode("", true)]))]);
        }), 128))])])])) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: "flex justify-end border-t border-slate-200 px-6 py-4"
        }, [_createElementVNode("button", {
          onClick: close,
          class: "rounded-lg bg-slate-100 px-4 py-2 text-sm text-slate-700 hover:bg-slate-200"
        }, "关闭")])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};